import { Route, Routes } from 'react-router-dom';
import { LayoutShell } from '../shared/Layout.tsx';
import { CambiarClavePage } from '../shared/CambiarClave.tsx';
import { DashboardPage } from './Dashboard.tsx';
import { PersonalPage } from './Personal.tsx';
import { CategoriasTarifasPage } from './CategoriasTarifas.tsx';
import { ClientesPage } from './Clientes.tsx';
import { SolicitudesAdminPage } from './SolicitudesAdmin.tsx';
import { NuevaSolicitudAdminPage } from './NuevaSolicitudAdmin.tsx';
import { HistorialAdminPage } from './HistorialAdmin.tsx';
import { QrAdminPage } from './QrAdmin.tsx';
import { LiquidacionesPage } from './Liquidaciones.tsx';
import { ReportesPage } from './Reportes.tsx';
import { AyudaAdminPage } from './Ayuda.tsx';

const nav = [
  { to: '/admin', label: 'Inicio', icon: 'dashboard' },
  { to: '/admin/personal', label: 'Personal', icon: 'group' },
  { to: '/admin/categorias', label: 'Categorías', icon: 'category' },
  { to: '/admin/clientes', label: 'Clientes', icon: 'business' },
  { to: '/admin/solicitudes', label: 'Solicitudes', icon: 'list_check' },
  { to: '/admin/nueva', label: 'Nueva', icon: 'add_circle' },
  { to: '/admin/historial', label: 'Historial', icon: 'history' },
  { to: '/admin/qr', label: 'QR', icon: 'qr_code' },
  { to: '/admin/liquidaciones', label: 'Liquidaciones', icon: 'payments' },
  { to: '/admin/reportes', label: 'Reportes', icon: 'bar_chart' },
];

export function AdminApp() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <LayoutShell
            titulo="Panel Admin"
            items={nav}
            accent="primario"
            ayudaTo="/admin/ayuda"
            cuentaTo="/admin/cuenta"
          />
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="personal" element={<PersonalPage />} />
        <Route path="categorias" element={<CategoriasTarifasPage />} />
        <Route path="clientes" element={<ClientesPage />} />
        <Route path="solicitudes" element={<SolicitudesAdminPage />} />
        <Route path="nueva" element={<NuevaSolicitudAdminPage />} />
        <Route path="historial" element={<HistorialAdminPage />} />
        <Route path="qr" element={<QrAdminPage />} />
        <Route path="liquidaciones" element={<LiquidacionesPage />} />
        <Route path="reportes" element={<ReportesPage />} />
        <Route path="ayuda" element={<AyudaAdminPage />} />
        <Route path="cuenta" element={<CambiarClavePage />} />
      </Route>
    </Routes>
  );
}
